import { Box, Divider } from '@mui/material'
import Input from 'components/shared/textFields/Input'
import TimeMaskedInput from 'components/shared/textFields/TimeMaskedInput'
import { Controller, useFormContext } from 'react-hook-form'
import { CardStandart } from 'ui/CardStandart'
import { TypographyHeader } from 'ui/typography/TypographyHeader'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
import { IMilkingFieldForm, IMilkingForm } from '../types/milkingForm'

type ShiftCardProps = {
	shiftInfo: IMilkingFieldForm
}

const ShiftCard = ({ shiftInfo }: ShiftCardProps) => {
	const {
		control,
		formState: { errors },
	} = useFormContext<IMilkingForm>()

	return (
		<CardStandart
			sx={{
				padding: '24px',
				display: 'flex',
				flexDirection: 'column',
				gap: '24px',
			}}
		>
			<Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
				<TypographyHeader>{shiftInfo.label}</TypographyHeader>

				<Box display='flex' alignItems='center' gap='24px'>
					<TypographyPrimary>
						Допустимое отклонение по времени начала смены
					</TypographyPrimary>
					<Box
						sx={{
							width: '120px',
							'& .MuiInputBase-input': { textAlign: 'center' },
						}}
					>
						<Controller
							name={shiftInfo.deviation}
							control={control}
							render={({ field }) => (
								<Input
									label=''
									placeholder='Минуты'
									width='120px'
									value={field.value}
									onChange={e => {
										const value = e.target.value.replace(/\D/g, '')
										field.onChange(value)
									}}
									isError={Boolean(errors?.[shiftInfo.deviation])}
									helperText={errors?.[shiftInfo.deviation]?.message}
									endAdornment={
										field.value ? (
											<TypographySecondary14>мин</TypographySecondary14>
										) : null
									}
									isMultiline={false}
								/>
							)}
						/>
					</Box>
				</Box>

				<Box display='flex' flexDirection='column' gap='16px'>
					<Box display='flex' alignItems='center' gap='40px'>
						<Box sx={{ width: '130px' }}>
							<TypographySecondary>Доильный зал</TypographySecondary>
						</Box>
						<Box sx={{ width: '90px' }}>
							<TypographySecondary>Начало</TypographySecondary>
						</Box>
						<Box sx={{ width: '100px' }}>
							<TypographySecondary>Окончание</TypographySecondary>
						</Box>
					</Box>

					<Divider />

					{shiftInfo.halls?.map((hall, i) => (
						<Box
							key={hall.milk_hall}
							display='flex'
							alignItems='center'
							gap='8px'
						>
							<Box sx={{ width: '160px', alignSelf: 'flex-start' }}>
								<TypographyPrimary>{hall.milk_hall}</TypographyPrimary>
							</Box>
							<Box sx={{ width: '120px' }}>
								<Controller
									name={`${shiftInfo.id}.halls.${i}.start`}
									control={control}
									render={({ field }) => (
										<TimeMaskedInput
											label=''
											placeholder='Время'
											width='120px'
											value={field.value}
											onChange={field.onChange}
											isError={Boolean(
												errors?.[shiftInfo.id]?.halls?.[i]?.start,
											)}
											helperText={
												errors?.[shiftInfo.id]?.halls?.[i]?.start?.message
											}
										/>
									)}
								/>
							</Box>
							<Box sx={{ width: '120px' }}>
								<Controller
									name={`${shiftInfo.id}.halls.${i}.end`}
									control={control}
									render={({ field }) => (
										<TimeMaskedInput
											label=''
											placeholder='Время'
											width='120px'
											value={field.value}
											onChange={field.onChange}
											isError={Boolean(errors?.[shiftInfo.id]?.halls?.[i]?.end)}
											helperText={
												errors?.[shiftInfo.id]?.halls?.[i]?.end?.message
											}
										/>
									)}
								/>
							</Box>
						</Box>
					))}
				</Box>
			</Box>
		</CardStandart>
	)
}

export default ShiftCard
